import { render, staticRenderFns } from "./ObsequiosModalPerseo.vue?vue&type=template&id=93c8a3bc&scoped=true"
import script from "./ObsequiosModalPerseo.vue?vue&type=script&lang=js"
export * from "./ObsequiosModalPerseo.vue?vue&type=script&lang=js"
import style0 from "./ObsequiosModalPerseo.vue?vue&type=style&index=0&id=93c8a3bc&prod&scoped=true&lang=css"
import style1 from "./ObsequiosModalPerseo.vue?vue&type=style&index=1&id=93c8a3bc&prod&scoped=true&lang=css"
import style2 from "./ObsequiosModalPerseo.vue?vue&type=style&index=2&id=93c8a3bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c8a3bc",
  null
  
)

export default component.exports